"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallArrowUpDown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var SmallArrowUpDown = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? helios_styles_1.icon.default : _c, upArrowColor = _a.upArrowColor, downArrowColor = _a.downArrowColor;
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: downArrowColor !== null && downArrowColor !== void 0 ? downArrowColor : color, fillRule: "evenodd", d: "M7.28026 16.2802C6.80778 15.8077 7.14241 14.9999 7.81059 14.9999H16.1893C16.8574 14.9999 17.1921 15.8077 16.7196 16.2802L12.5303 20.4696C12.2374 20.7625 11.7625 20.7625 11.4696 20.4696L7.28026 16.2802Z", clipRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { fill: upArrowColor !== null && upArrowColor !== void 0 ? upArrowColor : color, fillRule: "evenodd", d: "M7.28026 7.71956C6.80778 8.19203 7.14241 8.99989 7.81059 8.99989H16.1893C16.8574 8.99989 17.1921 8.19203 16.7196 7.71956L12.5303 3.53022C12.2374 3.23732 11.7625 3.23732 11.4696 3.53022L7.28026 7.71956Z", clipRule: "evenodd" })] })));
};
exports.SmallArrowUpDown = SmallArrowUpDown;
